"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Group = function Group(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 40 40",
    width: "40",
    height: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.75,7.75c0,0.969-0.227,1.924-0.663,2.789c-0.096,0.194-0.055,0.428,0.1,0.579c0.878,0.881,2.069,1.378,3.313,1.382 c2.623,0,4.75-2.127,4.75-4.75S19.123,3,16.5,3c-1.245,0.003-2.439,0.5-3.318,1.382c-0.155,0.151-0.196,0.385-0.1,0.579 C13.52,5.826,13.749,6.781,13.75,7.75z M16.5,13c-0.808,0-1.611,0.133-2.377,0.393c-0.262,0.087-0.403,0.371-0.316,0.633 c0.024,0.071,0.063,0.136,0.116,0.19c1.651,1.675,2.576,3.932,2.577,6.284c0,0.276,0.224,0.5,0.5,0.5h6.5 c0.276,0,0.5-0.224,0.5-0.5C23.996,16.36,20.64,13.004,16.5,13z M7.5,3c2.623,0,4.75,2.127,4.75,4.75S10.123,12.5,7.5,12.5 s-4.75-2.127-4.75-4.75S4.877,3,7.5,3z M15,20.5c0-4.142-3.358-7.5-7.5-7.5S0,16.358,0,20.5C0,20.776,0.224,21,0.5,21h14 C14.776,21,15,20.776,15,20.5z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Group.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Group.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Group;